import { render, staticRenderFns } from "./SubStatusSelect.vue?vue&type=template&id=520d161a&"
import script from "./SubStatusSelect.vue?vue&type=script&lang=js&"
export * from "./SubStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports